export const dateSplit = (dateStr: string, splitValue: string) => {
    const parts = dateStr.split(splitValue);
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);

    const dateObj = new Date(year, month - 1, day);
    return dateObj
}